import { AfterViewChecked, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { equals } from '@awp/core/utils';
import { ContentProvider } from '../content.provider';
var ContentDirective = /** @class */ (function () {
    function ContentDirective(contentProvider, element, changeDetectorRef) {
        var _this = this;
        this.contentProvider = contentProvider;
        this.element = element;
        this.changeDetectorRef = changeDetectorRef;
        // subscribe to onLangChange event, in case the language changes
        this.onLangChangeSubscription = this.contentProvider.onLangChanged
            .subscribe(function (p) {
            _this.checkNodes(true);
        });
    }
    Object.defineProperty(ContentDirective.prototype, "content", {
        set: function (key) {
            if (key) {
                this.key = key;
                this.checkNodes();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentDirective.prototype, "contentParams", {
        set: function (params) {
            if (!equals(this.currentParams, params)) {
                this.currentParams = params;
                this.checkNodes(true);
            }
        },
        enumerable: true,
        configurable: true
    });
    ContentDirective.prototype.ngAfterViewChecked = function () {
        this.checkNodes();
    };
    ContentDirective.prototype.checkNodes = function (forceUpdate) {
        if (forceUpdate === void 0) { forceUpdate = false; }
        var nodes = this.element.nativeElement.childNodes;
        // if the element is empty
        if (!nodes.length) {
            // we add the key as content
            this.setContent(this.element.nativeElement, this.key);
            nodes = this.element.nativeElement.childNodes;
        }
        for (var i = 0; i < nodes.length; ++i) {
            var node = nodes[i];
            if (node.nodeType === 3) { // node type 3 is a text node
                var key = void 0;
                if (this.key) {
                    key = this.key;
                    if (forceUpdate) {
                        node.lastKey = null;
                    }
                }
                else {
                    var content = this.getContent(node);
                    var trimmedContent = content.trim();
                    if (trimmedContent.length) {
                        // we want to use the content as a key, not the translation value
                        if (content !== node.currentValue) {
                            key = trimmedContent;
                            // the content was changed from the user, we'll use it as a reference if needed
                            node.originalContent = this.getContent(node);
                        }
                        else if (node.originalContent && forceUpdate) { // the content seems ok, but the lang has changed
                            node.lastKey = null;
                            // the current content is the translation, not the key, use the last real content as key
                            key = node.originalContent.trim();
                        }
                    }
                }
                this.updateValue(key, node);
            }
        }
    };
    ContentDirective.prototype.updateValue = function (key, node) {
        var _this = this;
        if (key) {
            if (node.lastKey === key && this.lastParams === this.currentParams) {
                return;
            }
            this.lastParams = this.currentParams;
            this.contentProvider.get(key, this.currentParams)
                .subscribe(function (res) {
                if (res !== key) {
                    node.lastKey = key;
                }
                if (!node.originalContent) {
                    node.originalContent = _this.getContent(node);
                }
                node.currentValue = res != null ? res : (node.originalContent || key);
                // we replace in the original content to preserve spaces that we might have trimmed
                _this.setContent(node, _this.key ? node.currentValue : node.originalContent.replace(key, node.currentValue));
                _this.changeDetectorRef.markForCheck();
            });
        }
    };
    ContentDirective.prototype.getContent = function (node) {
        return node.textContent != null ? node.textContent : node.data;
    };
    ContentDirective.prototype.setContent = function (node, content) {
        if (node.textContent != null) {
            node.textContent = content;
        }
        else {
            node.data = content;
        }
    };
    ContentDirective.prototype.ngOnDestroy = function () {
        this.onLangChangeSubscription.unsubscribe();
        this.onLangChangeSubscription = undefined;
    };
    return ContentDirective;
}());
export { ContentDirective };
